(function () {
  function DICompanyStatic() {
    "use strict";
    var context = this;
    context.name = "CompanyStatic";
    context.init = function () { };
     context.ApiUrl = "https://olivedashopifysync.ziplingo.com";
    context.ApiMethod = {
      CommonSettings : {
        GetStates: context.ApiUrl + "/api/SICommon/GetStates"
      },
      Customer: {
        GetCustomer: context.ApiUrl + "/api/SICustomer/GetCustomer",
        CreateCustomer: context.ApiUrl + "/api/SICustomer/CreateCustomer",
        GetCustomerSite: "https://sync1.connectolive.com/getWebsite/",
        FindEnroller: context.ApiUrl + "/api/SICustomer/findenroller",
        GetCustomWebsiteInfoByID: context.ApiUrl + "/api/SICustomer/GetCustomWebsiteInfoByID",
        VerifyEmail: context.ApiUrl + "/api/SICustomer/VerifyEmail",
        VerifyEmailExists: context.ApiUrl + "/api/SICustomer/VerifyEmailExists",
        VerifyPhoneExists: context.ApiUrl + "/api/SICustomer/VerifyPhoneExists",
        VerifyUserName: context.ApiUrl + "/api/SICustomer/verifyusername",
        ValidateTaxId: context.ApiUrl + "/api/public/validatessn",
        CreateAddress: context.ApiUrl + "/api/CustomerAddress/CreateCustomerAddress",
        UpdateAddress: context.ApiUrl + "/api/CustomerAddress/UpdateCustomerAddress",
        GetCustomerInfoByEmail: context.ApiUrl + "/api/dspublic/Customer/GetCustomersByEmail",
        ChangePassword: context.ApiUrl + "/api/SICustomer/ChangePassword",
      },
      Order: {
        GetShipMethod: "",
        CalculateOrder: context.ApiUrl + "/api/SIorder/calculateorder",
        CreateOrder: context.ApiUrl + "/api/SIorder/CreateOrder",
      },
      Payment: {
        GetPaymentType: context.ApiUrl + "/api/SIPayment/GetPaymentType",
        GetHostedPaymentData:
          context.ApiUrl + "/api/SIPayment/GetHostedPaymentData",
      },
      Enrollment: {
        GetShopifyCustomer: context.ApiUrl + "/api/Customer/GetCustomer",
        SubmitApplication: context.ApiUrl + "/api/Enrollment/SubmitApplication",
        GetShippingMethods: "https://sync1.connectolive.com/enrollment/updateShipping",
        createCheckoutID: context.ApiUrl + "/api/ShopifySF/Checkout/checkoutCreateUsingLineItemWithAttribute",
        saveCustomFields: context.ApiUrl + "/api/ShopifySF/Checkout/CreateEnrollmentExtraFields",
        calculateShippingTotal: context.ApiUrl + "/api/ShopifySF/Checkout/checkoutShippingLineUpdate",
        updateEmailtoCheckout: context.ApiUrl + "/api/ShopifySF/Checkout/checkoutEmailUpdate",
        GetProduct: context.ApiUrl + "/api/ProductController/GetProduct",
        customerCreate: context.ApiUrl + "/api/ShopifySF/Customer/customerCreate",
      },
    };

    context.shopifyCurrency = "USD";
    context.obtainStaticEndpoints = function () {
      return context.ApiMethod;
    };
    return this;
  }
  var DICompanyStaticInstance = new DICompanyStatic();
  window.DIMainInstance.injectReference(
    DICompanyStaticInstance.name,
    DICompanyStaticInstance
  );
  DICompanyStaticInstance.init();
})();
